import React, { FunctionComponent, MouseEvent } from 'react';

import { Row, Col, Card } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';

import { ReviewActionsMenuContainer } from 'reviews2/feed/review-yeti/actions-container/ActionsMenuContainer';
import { ReviewAttributions } from 'reviews2/feed/review-yeti/attributions/ReviewAttributions';
import { ReviewDate } from 'reviews2/feed/review-yeti/date/ReviewDate';
import { ReviewHistoryLink } from 'reviews2/feed/review-yeti/history/review-history-link/ReviewHistoryLink';
import { ReviewLabels } from 'reviews2/feed/review-yeti/labels/ReviewLabels';
import { ReviewLocation } from 'reviews2/feed/review-yeti/location/ReviewLocation';
import { ReviewPoster } from 'reviews2/feed/review-yeti/poster/ReviewPoster';
import { ReviewRepliesContainer } from 'reviews2/feed/review-yeti/replies-container/ReviewRepliesContainer';
import { useReview } from 'reviews2/feed/review-yeti/Review.store';
import { ContextProps } from 'reviews2/feed/review-yeti/Review.types';
import { ReviewSource } from 'reviews2/feed/review-yeti/source/ReviewSource';
import { TemplateFieldCategory } from 'reviews2/feed/review-yeti/template/field/TemplateFieldCategory';
import { TemplateFieldComment } from 'reviews2/feed/review-yeti/template/field/TemplateFieldComment';
import { TemplateFieldProperty } from 'reviews2/feed/review-yeti/template/field/TemplateFieldProperty';
import { TemplateFieldRating } from 'reviews2/feed/review-yeti/template/field/TemplateFieldRating';
import { TemplateFieldSubRating } from 'reviews2/feed/review-yeti/template/field/TemplateFieldSubRating';
import { TemplateFieldTitle } from 'reviews2/feed/review-yeti/template/field/TemplateFieldTitle';

import 'reviews2/feed/review-yeti/card-north-star/ReviewCardNorthStar.scss';

export const ReviewCardNorthStar: FunctionComponent<ContextProps> = ({ context }) => {
    const { t } = useTranslation('reviews2');
    const [{ review }] = useReview();
    const { reviewClick } = context.handlers!;

    return (
        <Card
            className="r4e-review-card-north-star"
            onClick={(event: MouseEvent<HTMLElement>): void => reviewClick?.(review!, event)}
        >
            <Card.Body>
                {review ? (
                    <>
                        <Row>
                            <Col xs={12}>
                                <Row>
                                    <Col>
                                        <Row className="d-flex gap-2">
                                            <ReviewSource context={context} />

                                            <div className="d-flex flex-column">
                                                <TemplateFieldRating context={context} />
                                                <ReviewLocation context={context} />
                                            </div>
                                        </Row>
                                        <Row className="align-items-center text-muted small">
                                            <ReviewPoster context={context} />
                                            <ReviewDate context={context} />
                                        </Row>
                                        <Row>
                                            <ReviewLabels context={context} />
                                        </Row>
                                    </Col>
                                    <Col className="d-flex justify-content-end align-items-start">
                                        <ReviewHistoryLink context={context} />
                                        {context.profile && context.config ? (
                                            <ReviewActionsMenuContainer context={context} />
                                        ) : null}
                                    </Col>
                                </Row>
                            </Col>
                        </Row>
                        <Row>
                            <Col xs={12} className="pl-0">
                                <TemplateFieldComment context={context} />
                                <TemplateFieldCategory context={context} />
                                <ReviewAttributions context={context} />
                                <TemplateFieldTitle context={context} />
                                <TemplateFieldSubRating context={context} />
                                <TemplateFieldProperty context={context} />
                                <ReviewRepliesContainer context={context} />
                            </Col>
                        </Row>
                    </>
                ) : (
                    <Row>
                        <Col xs={12}>
                            <div className="text-center text-muted">{t('REVIEW_NO_DATA')}</div>
                        </Col>
                    </Row>
                )}
            </Card.Body>
        </Card>
    );
};
